// Base set of tracking cookie parameter keys
export const TrackingCookieKeys = [
  // keep sorted ascending please
  "ad_id",
  "customer_id",
  "dclid",
  "fbclid",
  "gad_source",
  "gbraid",
  "gclid",
  "gclsrc",
  "http_referer",
  "iad-adgroup-id",
  "iad-campaign-id",
  "iad-keyword-id",
  "li_fat_id",
  "matchtype",
  "msclkid",
  "sccid",
  "segmentanonymousid",
  "timestamp",
  "ttclid",
  "twclid",
  "utm_adgroup",
  "utm_audience",
  "utm_campaign",
  "utm_content",
  "utm_creative",
  "utm_medium",
  "utm_placement",
  "utm_source",
  "utm_term",
  "visitor_id",
  "wbraid",
  "wt.mc_id",
  "wt.tsrc",
] as const;
